<div class="navigation-container">
  @if (!currentNavigationItemService.currentNavigationItem().hideHeader) {
    <maintenance-banner></maintenance-banner>
    <app-header></app-header>
  }
  <main-container>
    <ng-content></ng-content>
  </main-container>
</div>

<reset-startpage-popup />
<feedback-popup />
<feedback-confirmation-popup />
